import { connect } from 'react-redux';

import { showAppointmentInfo } from 'modules/queues/common/actions/appointmentInfo';
import { makeAppointmentReadPermissions } from 'modules/common/selectors/permissions';
import { AppointmentCard } from 'modules/queues/common/components';
import { makeMappedAppointmentSelector } from 'modules/queues/common/selectors/appointmentsByQueueType';

const mapStateToProps = (state, ownProps) => {
  const appointment = state.queues.schedule.appointments.entities[ownProps.appointmentId];

  return {
    ...makeMappedAppointmentSelector(ownProps.appointmentId)(state),
    permissions: makeAppointmentReadPermissions(appointment),
  };
};

export default connect(
  mapStateToProps,
  { showAppointmentInfo },
)(AppointmentCard);
